export enum ActivationStatus {
    SUBMITTED = 'SUBMITTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING'
}

export enum WatchesEligibilityCode {
    ONGOING_ACTIVATION = 'ONGOING_ACTIVATION',
    ALREADY_PAIRED = 'ALREADY_PAIRED',
    ALREADY_ACTIVE_IN_PAIRED = 'ALREADY_ACTIVE_IN_PAIRED',
    LINE_PAIR_EXISTS = 'LINE_PAIR_EXISTS',
    ACCOUNT_NOT_ACTIVE = 'ACCOUNT_NOT_ACTIVE',
    PAIRED_WITH_SAME_LINE = 'PAIRED_WITH_SAME_LINE',
    PAIRED_WITH_DIFFERENT_LINE = 'PAIRED_WITH_DIFFERENT_LINE',
    LINE_NOT_FOUND = 'LINE_NOT_FOUND',
    DEVICE_NOT_IN_DMD = 'DEVICE_NOT_IN_DMD',
    DEVICE_IN_PIB = 'DEVICE_IN_PIB',
    DEVICE_IN_LOST_STOLEN = 'DEVICE_IN_LS',
    SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
    NON_HSD_CUSTOMER = 'NON_HSD_CUSTOMER'
}

export enum WatchEligibilityTransactionStatus {
    SUBMITTED = 'SUBMITTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}

export enum WatchPairingMode {
    STANDALONE = 'STANDALONE'
}

export enum AnalyticsErrorMessageTemplates {
    ACTIVATION_FAILED = 'Error|Activation|[TYPE]'
}

export enum DeviceActivationType {
    WATCH = 'Pair Watch|[ERRORCODE]'
}

export const WATCH_STATUS_RECHECK_INTERVAL: number = 5000;

export const MAXIMUM_WATCH_LINES: number = 5;

export enum WatchSupportActivation {
    NEW = 'NEW',
    REPLACE = 'REPLACE',
    NEW_ESIM = 'NEW_ESIM',
    CHANGE_HOST = 'CHANGE_HOST'
}

export enum HostIdentifierType {
    ICCID = 'ICCID',
    MDN = 'MDN'
}

export const XM_MOBILE_WATCH: string = 'Xfinity Mobile';

export const CBM_MOBILE_WATCH: string = 'Comcast Business';

export const NETWORK_TMO: string = 'TMO';

export const TMOSTATUS_RECHECK_INTERVAL: number = 30000;

export const TMOSTATUS_RECHECK_TOTAL_ATTEMPTS: number = 30;

